import { useRef, useState } from "react";

interface InputSubjectNameProps {
  subjectName: string;
  setSubjectName: React.Dispatch<React.SetStateAction<string>>;
}

export const InputSubjectName: React.FC<InputSubjectNameProps> = ({
  subjectName,
  setSubjectName,
}) => {
  // IME 変換中かどうかのフラグ
  const isImeOn = useRef(false);
  //入力フォーム用
  const inputRef = useRef<HTMLInputElement>(null);
  const SINGLE_BYTE_ALPHANUMELIC_CHAR_MAX_LENGTH = 30; // 半角文字の最大数
  // inputのmaxLengthに入れる数を格納(数は再計算される)
  const inputMaxLength = useRef(SINGLE_BYTE_ALPHANUMELIC_CHAR_MAX_LENGTH);
  
  // 一括削除ボタン表示非表示用
  const [hasValue,setHasValue] = useState<boolean>(!!subjectName);

  const handleChange = (inputText: string) => {
    let length = 0;
    let formattedValue = "";

    if (inputText === "") {
      // Memo:Chrome ではテキストクリア時に onCompositionEnd が呼ばれないことがある
      isImeOn.current = false;
    } else if (isImeOn.current) {
      return; // IME 変換中は何もしない
    }
    for (let char of inputText) {
      // eslint-disable-next-line no-control-regex
      length += char.match(/[^\x00-\x7F]/) ? 2 : 1; //1Byte文字なら1、それ以外なら2で加算
      if (length > SINGLE_BYTE_ALPHANUMELIC_CHAR_MAX_LENGTH) {
        // lengthを超過した分を引いて最大値を設定
        inputMaxLength.current = inputText.length - Math.ceil(length % 30);
        break;
      } else if (length === SINGLE_BYTE_ALPHANUMELIC_CHAR_MAX_LENGTH) {
        formattedValue += char;
        inputMaxLength.current = inputText.length;
        break;
      } else {
        formattedValue += char;
      }
    }
    if (length < SINGLE_BYTE_ALPHANUMELIC_CHAR_MAX_LENGTH) {
      //入力文字数が最大に満たなかったら最大数を元に戻す
      inputMaxLength.current = SINGLE_BYTE_ALPHANUMELIC_CHAR_MAX_LENGTH;
    }

    if (inputRef.current) {
      (inputRef.current as HTMLInputElement).value = formattedValue; //加工後の値を入力フォームに設定
    }
    setSubjectName(formattedValue); //subjectNameは親が管理しているので入力フォームの値をコールバック経由で設定
  };

  return (
    <div className="relative w-full">
      <input
        ref={inputRef}
        type="text"
        className="block appearance-none bg-white placeholder-gray-500 border border-sub-blue rounded w-full py-3 px-4 mx-auto text-black leading-5 focus:outline-none"
        onChange={(e) => {
          setHasValue(e.target.value.length > 0);
          handleChange(e.target.value);
        }}
        defaultValue={subjectName} //valueにstateを設定するとonCompositionEndが発火しなかったので初期値だけstateを設定
        maxLength={inputMaxLength.current} //最大長を可変にする(全角文字で長さが変わる)
        onCompositionStart={() => {
          isImeOn.current = true; // IME 入力中
        }}
        onCompositionEnd={(e) => {
          isImeOn.current = false; // IME 入力完了
          handleChange((e.target as HTMLInputElement).value);
        }}
      />
      {/* テキストボックス内のテキスト一括削除ボタン */}
      {hasValue &&(
        <button 
          type="button"
          className="absolute right-3 top-[29%] leading-5 text-[20px] text-center items-center"
          onClick={() => {
            if (inputRef.current) {
              inputRef.current.value = "";
            }
            setHasValue(false);
            handleChange("");
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};
